import { render, staticRenderFns } from "./CoreProductTable.vue?vue&type=template&id=dab4aa2c&scoped=true"
import script from "./CoreProductTable.vue?vue&type=script&lang=js"
export * from "./CoreProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab4aa2c",
  null
  
)

export default component.exports